'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$51() {
  this.aU3 = null;
  this.aU4 = false;
}
export { $c_Lpresto_GroupRestrictionsView$$anon$51 as $c_Lpresto_GroupRestrictionsView$$anon$51 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$51.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$51;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$51() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$51 as $h_Lpresto_GroupRestrictionsView$$anon$51 };
$h_Lpresto_GroupRestrictionsView$$anon$51.prototype = $p;
$p.P = (function() {
  if ((!this.aU4)) {
    this.aU3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aU4 = true;
  }
  return this.aU3;
});
var $d_Lpresto_GroupRestrictionsView$$anon$51 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$51, "presto.GroupRestrictionsView$$anon$51", ({
  IX: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$51 as $d_Lpresto_GroupRestrictionsView$$anon$51 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$51.js.map
